import React from 'react';
import { Card, Row, Timeline, Col } from 'antd';
import { PrimaryTableRowText } from '../../../../../../shared/globalStyling/styledText';
import moment from 'moment';
import { ArrowDownOutlined } from '@ant-design/icons';
const { Item } = Timeline;

const SessionExpand = ({ clicksList, journey }) => {
  return (
    <Card bodyStyle={{ overflowY: 'auto', height: '500px' }}>
      <Timeline>
        <Item>Page View Journey</Item>
        {clicksList.map((click) => {
          return (
            <Item dot={<ArrowDownOutlined />}>
              <Row>
                <Col span={4}>
                  <PrimaryTableRowText
                    text={`${moment(click.viewTime).format('YYYY-MM-DD HH:mm:ss')}`}
                  />
                </Col>
                <Col span={4}>
                  <PrimaryTableRowText text={'Page View'} />
                </Col>
                <Col span={4}>
                  <PrimaryTableRowText text={click.pageURL} />
                </Col>
              </Row>
            </Item>
          );
        })}
        <Item color="green">Session Journey</Item>
        {journey
          .filter((event) => event.event !== 'record')
          .map((event) => {
            return (
              <Item color="green" dot={<ArrowDownOutlined />}>
                <Row>
                  <Col span={4}>
                    <PrimaryTableRowText
                      text={`${moment(event.dateTime).format('YYYY-MM-DD HH:mm:ss')}`}
                    />
                  </Col>
                  <Col span={4}>
                    <PrimaryTableRowText text={event.event} />
                  </Col>
                  <Col span={4}>
                    <PrimaryTableRowText text={event.url} />
                  </Col>
                </Row>
              </Item>
            );
          })}
      </Timeline>
    </Card>
  );
};

export default SessionExpand;
